import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import { RECEIVE_PROPERTY_ASSOCIATIONS } from './properties'

// action types
const RECEIVE_LEASES = 'rp/leases/RECEIVE_LEASES'

export default function leases(state = {}, action) {
  switch (action.type) {
    case RECEIVE_PROPERTY_ASSOCIATIONS:
      return action.payload.leases
    case RECEIVE_LEASES:
      return action.payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}
